// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "0c6abb0e9f6e9f899e79" + ".chunk.js";
};